import ImageOverlay from "./functional";
export default ImageOverlay;
